import CancelIcon from "@mui/icons-material/Clear";
import { Checkbox, InputAdornment } from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  ACTION_ACCEPT,
  ACTION_APPROVE,
  ACTION_CANCEL,
  ACTION_CANCEL_ACCEPT,
  ACTION_CANCEL_APPROVE,
  ACTION_CANCEL_DECLINE,
  ACTION_CANCEL_OFFER,
  ACTION_CANCEL_REFUSE,
  ACTION_DECLINE,
  ACTION_REFUSE,
  ACTION_REINSTATE,
  ACTION_RETRACT,
  FREEFORM_REASON_CHAR_LIMIT,
  TRADE_PAGE_TYPE,
} from "../util/constants";
import {
  validateCannedReason,
  validateReasonComments,
  validateSubmissionDeadline,
  validateVerbalCheck,
} from "../util/inputValidation";
import {
  ARE_YOU_SURE_YOU_WANT_TO_ACCEPT_MESSAGE,
  ARE_YOU_SURE_YOU_WANT_TO_APPROVE_MESSAGE,
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL_MESSAGE,
  ARE_YOU_SURE_YOU_WANT_TO_DECLINE_MESSAGE,
  ARE_YOU_SURE_YOU_WANT_TO_REFUSE_MESSAGE,
  ARE_YOU_SURE_YOU_WANT_TO_REINSTATE_MESSAGE,
  ARE_YOU_SURE_YOU_WANT_TO_RETRACT_MESSAGE,
  YOU_CANNOT_APPROVE_YOUR_OWN_TRADE_CANCELLATION_MESSAGE,
  YOU_CANNOT_APPROVE_YOUR_OWN_TRADE_MESSAGE,
  YOU_CANNOT_CANCEL_YOUR_OWN_TRADE_FROM_THE_TRADE_ADMIN_SCREEN_MESSAGE,
  YOU_CANNOT_REFUSE_YOUR_OWN_TRADE_CANCELLATION_MESSAGE,
  YOU_CANNOT_REFUSE_YOUR_OWN_TRADE_MESSAGE,
  YOU_CANNOT_REINSTATE_YOUR_OWN_TRADE_MESSAGE,
} from "../util/messageConstants";
import ConfirmButton from "./fundamentals/ConfirmButton";
import SlideUpTransition from "./fundamentals/SlideUpTransition";
import WarningDialog from "./fundamentals/WarningDialog";
import TradeFormActionConfirm from "./TradeFormActionConfirm.jsx";
import UnionContractCutoffTimeReminder from "./UnionContractCutoffTimeReminder";

export class TradeFormActionCheckDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerbalCheckChecked: false,
      verbalCheckErrors: "",
      cannedReason: "",
      cannedReasonErrors: "",
      reasonComments: "",
      reasonCommentsTouched: false,
      reasonCommentsErrors: "",
      isActionTriggered: false,
      isActionLoading: false,
      isActionError: false,
      isActionSuccess: false,
      actionErrors: "",
      submissionDeadlineWarningMessage: "",
      isReasonCommentsRequired: this.isReasonCommentsRequired(),
      isAdminTradeInvolved:
        this.props.loggedInUserData.isAdmin &&
        this.props.isAdminPage &&
        (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId ||
          this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDialogOpen !== this.props.isDialogOpen && this.props.isDialogOpen) {
      let submissionDeadlineWarningMessage = validateSubmissionDeadline(this.props.trade, this.props.actionSelected);
      this.setState({
        submissionDeadlineWarningMessage: submissionDeadlineWarningMessage,
        isReasonCommentsRequired: this.isReasonCommentsRequired(),
      });
    }
  }

  isVerbalCheckRequired() {
    return this.props.actionSelected === ACTION_CANCEL;
  }

  isCannedReasonRequired() {
    return (
      this.props.actionSelected === ACTION_REFUSE ||
      this.props.actionSelected === ACTION_CANCEL_REFUSE ||
      this.props.actionSelected === ACTION_CANCEL
    );
  }

  isReasonCommentsRequired() {
    return this.props.actionSelected === ACTION_REINSTATE;
  }

  isFormValidationSuccess() {
    let verbalCheckErrors = "";
    let cannedReasonErrors = "";
    let reasonCommentsErrors = "";
    let submissionDeadlineWarningMessage = "";

    verbalCheckErrors = validateVerbalCheck(this.state.isVerbalCheckChecked, this.isVerbalCheckRequired());
    cannedReasonErrors = validateCannedReason(this.state.cannedReason, this.isCannedReasonRequired());
    reasonCommentsErrors = validateReasonComments(this.state.reasonComments, this.state.isReasonCommentsRequired);
    submissionDeadlineWarningMessage = validateSubmissionDeadline(this.props.trade, this.props.actionSelected);
    this.setState({
      verbalCheckErrors: verbalCheckErrors,
      cannedReasonTouched: true,
      cannedReasonErrors: cannedReasonErrors,
      reasonCommentsTouched: true,
      reasonCommentsErrors: reasonCommentsErrors,
      submissionDeadlineWarningMessage: submissionDeadlineWarningMessage,
    });
    return (
      verbalCheckErrors === "" &&
      cannedReasonErrors === "" &&
      reasonCommentsErrors === "" &&
      submissionDeadlineWarningMessage === ""
    );
  }

  handleClickDialogOpen(event) {
    this.props.onClickDialogOpen(event);
  }

  handleClickDialogClose(event, reason) {
    if (reason && reason === "backdropClick") return;
    this.clearDialogState();
    this.props.onClickDialogClose(event, reason);
  }

  clearDialogState() {
    this.setState({
      isVerbalCheckChecked: false,
      verbalCheckErrors: "",
      cannedReason: "",
      cannedReasonErrors: "",
      reasonComments: "",
      reasonCommentsTouched: false,
      reasonCommentsErrors: "",
      isActionTriggered: false,
      isActionLoading: false,
      isActionError: false,
      isActionSuccess: false,
      actionErrors: "",
    });
  }

  handleSetIsActionError(isActionError) {
    this.setState({ isActionError: isActionError });
  }

  handleSetActionErrors(actionErrors) {
    this.setState({ actionErrors: actionErrors });
  }

  handleSetIsActionLoading(isActionLoading) {
    this.setState({ isActionTriggered: true, isActionLoading: isActionLoading });
  }

  handleSetIsActionSuccess(isActionSuccess) {
    if (isActionSuccess) {
      if (this.props.onTradeDialogClose) {
        this.props.onTradeDialogClose();
      }
    }
    this.setState({ isActionSuccess: isActionSuccess });
  }

  handleIsVerbalCheckChecked(event) {
    if (event.target.checked) {
      this.setState({ verbalCheckErrors: "" });
    }
    this.setState({ isVerbalCheckChecked: event.target.checked });
  }

  handleCannedReasonSelectChange(event) {
    this.setState({ cannedReason: event.target.value });
    if (event.target.value === "Other") {
      this.setState({ isReasonCommentsRequired: true });
    } else {
      this.setState({ isReasonCommentsRequired: this.isReasonCommentsRequired() });
    }
  }

  handleCannedReasonSelectBlur(event) {
    this.setState({ cannedReasonErrors: validateCannedReason(event.target.value) });
  }

  handleReasonCommentsChange(event) {
    this.setState({ reasonComments: event.target.value, reasonCommentsTouched: true });
  }

  handleReasonCommentsBlur(event) {
    this.setState({
      reasonCommentsErrors: validateReasonComments(event.target.value, this.state.isReasonCommentsRequired),
      reasonCommentsTouched: true,
    });
  }

  handleCommentsClear(event) {
    this.setState({
      reasonComments: "",
      reasonCommentsErrors: validateReasonComments("", this.state.isReasonCommentsRequired),
      reasonCommentsTouched: true,
    });
  }

  renderAcceptDialog() {
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_ACCEPT_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <UnionContractCutoffTimeReminder pageType={TRADE_PAGE_TYPE} />
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderRefuseDialog() {
    const CancelComments = () => {
      return (
        <IconButton size="small" className="cancel-icon-button" onMouseDown={this.handleCommentsClear.bind(this)}>
          <CancelIcon />
        </IconButton>
      );
    };
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_REFUSE_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.cannedReasonErrors !== "" ? (
              <FormControl variant="outlined">
                <InputLabel>Reason</InputLabel>
                <Select
                  id="tradeFormTypeSelectElement"
                  className="select-field"
                  value={this.state.cannedReason}
                  onChange={this.handleCannedReasonSelectChange.bind(this)}
                  onBlur={this.handleCannedReasonSelectBlur.bind(this)}
                  label="Reason"
                  error
                >
                  <MenuItem value="" disabled>
                    <em>Reason Options</em>
                  </MenuItem>
                  {this.renderReasonMenuItem("DAT Bid has not been awarded")}
                  {this.renderReasonMenuItem("Duplicate request")}
                  {this.renderReasonMenuItem("Employee is already working")}
                  {this.renderReasonMenuItem("Employee is scheduled off")}
                  {this.renderReasonMenuItem("Full shifts on same date must be submitted as Time Trade")}
                  {this.renderReasonMenuItem("Incorrect dates")}
                  {this.renderReasonMenuItem("Incorrect times")}
                  {this.renderReasonMenuItem("Ineligible Employee")}
                  {this.renderReasonMenuItem("Partial shift trade cannot be submitted as Time Trade")}
                  {this.renderReasonMenuItem("PTO Bid has not been awarded")}
                  {this.renderReasonMenuItem("Relief Shift selection incorrect")}
                  {this.renderReasonMenuItem("Submitted after CBA cutoff")}
                  {this.renderReasonMenuItem("Too much overlap")}
                  {this.renderReasonMenuItem("Other")}
                </Select>
                <FormHelperText error>{this.state.cannedReasonErrors}</FormHelperText>
              </FormControl>
            ) : (
              <FormControl variant="outlined">
                <InputLabel>Reason</InputLabel>
                <Select
                  id="tradeFormTypeSelectElement"
                  className="select-field"
                  value={this.state.cannedReason}
                  onChange={this.handleCannedReasonSelectChange.bind(this)}
                  onBlur={this.handleCannedReasonSelectBlur.bind(this)}
                  label="Reason"
                >
                  <MenuItem value="" disabled>
                    <em>Reason Options</em>
                  </MenuItem>
                  {this.renderReasonMenuItem("DAT Bid has not been awarded")}
                  {this.renderReasonMenuItem("Duplicate request")}
                  {this.renderReasonMenuItem("Employee is already working")}
                  {this.renderReasonMenuItem("Employee is scheduled off")}
                  {this.renderReasonMenuItem("Full shifts on same date must be submitted as Time Trade")}
                  {this.renderReasonMenuItem("Incorrect dates")}
                  {this.renderReasonMenuItem("Incorrect times")}
                  {this.renderReasonMenuItem("Ineligible Employee")}
                  {this.renderReasonMenuItem("Partial shift trade cannot be submitted as Time Trade")}
                  {this.renderReasonMenuItem("PTO Bid has not been awarded")}
                  {this.renderReasonMenuItem("Relief Shift selection incorrect")}
                  {this.renderReasonMenuItem("Submitted after CBA cutoff")}
                  {this.renderReasonMenuItem("Too much overlap")}
                  {this.renderReasonMenuItem("Other")}
                </Select>
              </FormControl>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.reasonCommentsTouched && this.state.reasonCommentsErrors !== "" ? (
              <TextField
                error
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                helperText={this.state.reasonCommentsErrors}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
                multiline
              />
            ) : (
              <TextField
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
                multiline
              />
            )}
            {this.state.reasonComments.length > FREEFORM_REASON_CHAR_LIMIT ? (
              <div className="character-limit-label-dialog character-limit-label-red">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            ) : (
              <div className="character-limit-label-dialog">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderCancelDialog() {
    const CancelComments = () => {
      return (
        <IconButton size="small" className="cancel-icon-button" onMouseDown={this.handleCommentsClear.bind(this)}>
          <CancelIcon />
        </IconButton>
      );
    };
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_CANCEL_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.verbalCheckErrors !== "" ? (
              <FormControl required component="fieldset" error className="checkbox-field">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isVerbalCheckChecked}
                      onChange={this.handleIsVerbalCheckChecked.bind(this)}
                      name="verbalCheck"
                      color="primary"
                      error
                    />
                  }
                  label="Have you contacted the Employees verbally?"
                  error
                />
                <FormHelperText className="checked-error" error>
                  {this.state.verbalCheckErrors}
                </FormHelperText>
              </FormControl>
            ) : (
              <FormControl required component="fieldset" className="checkbox-field">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isVerbalCheckChecked}
                      onChange={this.handleIsVerbalCheckChecked.bind(this)}
                      name="verbalCheck"
                      color="primary"
                    />
                  }
                  label="Have you contacted the Employees verbally?"
                />
              </FormControl>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.cannedReasonErrors !== "" ? (
              <FormControl variant="outlined">
                <InputLabel>Reason</InputLabel>
                <Select
                  id="tradeFormTypeSelectElement"
                  className="select-field"
                  value={this.state.cannedReason}
                  onChange={this.handleCannedReasonSelectChange.bind(this)}
                  onBlur={this.handleCannedReasonSelectBlur.bind(this)}
                  label="Reason"
                  error
                >
                  <MenuItem value="" disabled>
                    <em>Reason Options</em>
                  </MenuItem>
                  {this.renderReasonMenuItem("Employee has become ineligible")}
                  {this.renderReasonMenuItem("Other")}
                </Select>
                <FormHelperText error>{this.state.cannedReasonErrors}</FormHelperText>
              </FormControl>
            ) : (
              <FormControl variant="outlined">
                <InputLabel>Reason</InputLabel>
                <Select
                  id="tradeFormTypeSelectElement"
                  className="select-field"
                  value={this.state.cannedReason}
                  onChange={this.handleCannedReasonSelectChange.bind(this)}
                  onBlur={this.handleCannedReasonSelectBlur.bind(this)}
                  label="Reason"
                >
                  <MenuItem value="" disabled>
                    <em>Reason Options</em>
                  </MenuItem>
                  {this.renderReasonMenuItem("Employee has become ineligible")}
                  {this.renderReasonMenuItem("Other")}
                </Select>
              </FormControl>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.reasonCommentsTouched && this.state.reasonCommentsErrors !== "" ? (
              <TextField
                error
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                helperText={this.state.reasonCommentsErrors}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
              />
            ) : (
              <TextField
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
                multiline
              />
            )}
            {this.state.reasonComments.length > FREEFORM_REASON_CHAR_LIMIT ? (
              <div className="character-limit-label-dialog character-limit-label-red">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            ) : (
              <div className="character-limit-label-dialog">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderCancelRefuseDialog() {
    const CancelComments = () => {
      return (
        <IconButton size="small" className="cancel-icon-button" onMouseDown={this.handleCommentsClear.bind(this)}>
          <CancelIcon />
        </IconButton>
      );
    };
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_REFUSE_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.cannedReasonErrors !== "" ? (
              <FormControl variant="outlined">
                <InputLabel>Reason</InputLabel>
                <Select
                  id="tradeFormTypeSelectElement"
                  className="select-field"
                  value={this.state.cannedReason}
                  onChange={this.handleCannedReasonSelectChange.bind(this)}
                  onBlur={this.handleCannedReasonSelectBlur.bind(this)}
                  label="Reason"
                  error
                >
                  <MenuItem value="" disabled>
                    <em>Reason Options</em>
                  </MenuItem>
                  {this.renderReasonMenuItem("Employee has become ineligible")}
                  {this.renderReasonMenuItem("Shifts do not match")}
                  {this.renderReasonMenuItem("Submitted after CBA cutoff")}
                  {this.renderReasonMenuItem("Other")}
                </Select>
                <FormHelperText error>{this.state.cannedReasonErrors}</FormHelperText>
              </FormControl>
            ) : (
              <FormControl variant="outlined">
                <InputLabel>Reason</InputLabel>
                <Select
                  id="tradeFormTypeSelectElement"
                  className="select-field"
                  value={this.state.cannedReason}
                  onChange={this.handleCannedReasonSelectChange.bind(this)}
                  onBlur={this.handleCannedReasonSelectBlur.bind(this)}
                  label="Reason"
                >
                  <MenuItem value="" disabled>
                    <em>Reason Options</em>
                  </MenuItem>
                  {this.renderReasonMenuItem("Employee has become ineligible")}
                  {this.renderReasonMenuItem("Shifts do not match")}
                  {this.renderReasonMenuItem("Submitted after CBA cutoff")}
                  {this.renderReasonMenuItem("Other")}
                </Select>
              </FormControl>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.reasonCommentsTouched && this.state.reasonCommentsErrors !== "" ? (
              <TextField
                error
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
                helperText={this.state.reasonCommentsErrors}
              />
            ) : (
              <TextField
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
                multiline
              />
            )}
            {this.state.reasonComments.length > FREEFORM_REASON_CHAR_LIMIT ? (
              <div className="character-limit-label-dialog character-limit-label-red">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            ) : (
              <div className="character-limit-label-dialog">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderCancelOfferDialog() {
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_CANCEL_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <UnionContractCutoffTimeReminder pageType={TRADE_PAGE_TYPE} />
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderCancelAcceptDialog() {
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_ACCEPT_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <UnionContractCutoffTimeReminder pageType={TRADE_PAGE_TYPE} />
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderReinstateDialog() {
    const CancelComments = () => {
      return (
        <IconButton size="small" className="cancel-icon-button" onMouseDown={this.handleCommentsClear.bind(this)}>
          <CancelIcon />
        </IconButton>
      );
    };
    return (
      <Grid container>
        <Grid item xs={12} className="action-check-dialog-question">
          {ARE_YOU_SURE_YOU_WANT_TO_REINSTATE_MESSAGE}
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            {this.state.reasonCommentsTouched && this.state.reasonCommentsErrors !== "" ? (
              <TextField
                error
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                helperText={this.state.reasonCommentsErrors}
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
              />
            ) : (
              <TextField
                className="text-field"
                label="Comments"
                variant="outlined"
                value={this.state.reasonComments}
                onChange={this.handleReasonCommentsChange.bind(this)}
                onBlur={this.handleReasonCommentsBlur.bind(this)}
                multiline
                InputProps={{
                  endAdornment:
                    this.state.reasonComments !== "" ? (
                      <InputAdornment position="start">
                        <CancelComments />
                      </InputAdornment>
                    ) : (
                      ""
                    ),
                }}
              />
            )}
            {this.state.reasonComments.length > FREEFORM_REASON_CHAR_LIMIT ? (
              <div className="character-limit-label-dialog character-limit-label-red">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            ) : (
              <div className="character-limit-label-dialog">
                {this.state.reasonComments.length} / {FREEFORM_REASON_CHAR_LIMIT}
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    );
  }

  renderReasonMenuItem(reason) {
    return (
      <MenuItem key={reason} value={reason}>
        {reason}
      </MenuItem>
    );
  }

  renderDialogDetails() {
    switch (this.props.actionSelected) {
      case ACTION_ACCEPT:
        return this.renderAcceptDialog();
      case ACTION_DECLINE:
        return ARE_YOU_SURE_YOU_WANT_TO_DECLINE_MESSAGE;
      case ACTION_RETRACT:
        return ARE_YOU_SURE_YOU_WANT_TO_RETRACT_MESSAGE;
      case ACTION_APPROVE:
        return ARE_YOU_SURE_YOU_WANT_TO_APPROVE_MESSAGE;
      case ACTION_REFUSE:
        return this.renderRefuseDialog();
      case ACTION_CANCEL_OFFER:
        return this.renderCancelOfferDialog();
      case ACTION_CANCEL_ACCEPT:
        return this.renderCancelAcceptDialog();
      case ACTION_CANCEL_DECLINE:
        return ARE_YOU_SURE_YOU_WANT_TO_DECLINE_MESSAGE;
      case ACTION_CANCEL_APPROVE:
        return ARE_YOU_SURE_YOU_WANT_TO_APPROVE_MESSAGE;
      case ACTION_CANCEL_REFUSE:
        return this.renderCancelRefuseDialog();
      case ACTION_CANCEL:
        return this.renderCancelDialog();
      case ACTION_REINSTATE:
        return this.renderReinstateDialog();
      default:
        return `I don't understand the action you have selected. Action: ${this.props.actionSelected}`;
    }
  }

  renderDialogAdminInvolvedDetails() {
    switch (this.props.actionSelected) {
      case ACTION_APPROVE:
        return YOU_CANNOT_APPROVE_YOUR_OWN_TRADE_MESSAGE;
      case ACTION_REFUSE:
        return YOU_CANNOT_REFUSE_YOUR_OWN_TRADE_MESSAGE;
      case ACTION_CANCEL_APPROVE:
        return YOU_CANNOT_APPROVE_YOUR_OWN_TRADE_CANCELLATION_MESSAGE;
      case ACTION_CANCEL_REFUSE:
        return YOU_CANNOT_REFUSE_YOUR_OWN_TRADE_CANCELLATION_MESSAGE;
      case ACTION_CANCEL:
        return YOU_CANNOT_CANCEL_YOUR_OWN_TRADE_FROM_THE_TRADE_ADMIN_SCREEN_MESSAGE;
      case ACTION_REINSTATE:
        return YOU_CANNOT_REINSTATE_YOUR_OWN_TRADE_MESSAGE;
      default:
        return `You cant perform this action. Action: ${this.props.actionSelected}`;
    }
  }

  render() {
    return this.state.submissionDeadlineWarningMessage !== "" ? (
      <WarningDialog
        isDialogOpen={this.props.isDialogOpen}
        handleClickDialogClose={this.handleClickDialogClose.bind(this)}
        header="Warning"
        message={this.state.submissionDeadlineWarningMessage}
        severity={"error"}
      />
    ) : this.state.isAdminTradeInvolved ? (
      <WarningDialog
        isDialogOpen={this.props.isDialogOpen}
        handleClickDialogClose={this.handleClickDialogClose.bind(this)}
        header="Warning"
        message={this.renderDialogAdminInvolvedDetails()}
        severity={"error"}
      />
    ) : (
      <Dialog
        className="action-check-dialog"
        data-testid="action-check-dialog"
        fullWidth
        maxWidth="md"
        open={this.props.isDialogOpen}
        TransitionComponent={SlideUpTransition}
        keepMounted
        onClose={this.handleClickDialogClose.bind(this)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" className="detail-dialog-title">
          Confirm
        </DialogTitle>
        <DialogContent className="action-check-dialog-content">
          <Grid container>
            <Grid item xs={12}>
              <DialogContentText component={"div"} id="alert-dialog-slide-description">
                {this.renderDialogDetails()}
                {this.state.isActionError ? <Alert severity="error">{this.state.actionErrors}</Alert> : ""}
              </DialogContentText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="action-check-dialog-buttons">
          <ConfirmButton
            variant="outlined"
            color="primary"
            onClick={this.handleClickDialogClose.bind(this)}
            isLoading={this.state.isActionLoading}
          >
            No
          </ConfirmButton>
          <TradeFormActionConfirm
            loggedInUserData={this.props.loggedInUserData}
            eid={this.props.loggedInUserData.eid}
            isAdmin={this.props.loggedInUserData.isAdmin}
            trade={this.props.trade}
            actionSelected={this.props.actionSelected}
            handleClickDialogClose={this.handleClickDialogClose.bind(this)}
            handleSetIsActionError={this.handleSetIsActionError.bind(this)}
            handleSetActionErrors={this.handleSetActionErrors.bind(this)}
            handleSetIsActionLoading={this.handleSetIsActionLoading.bind(this)}
            handleSetIsActionSuccess={this.handleSetIsActionSuccess.bind(this)}
            isActionLoading={this.state.isActionLoading}
            cannedReason={this.state.cannedReason}
            reasonComments={this.state.reasonComments}
            isFormValidationSuccess={this.isFormValidationSuccess.bind(this)}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

TradeFormActionCheckDialog.propTypes = {
  loggedInUserData: PropTypes.object.isRequired,
  trade: PropTypes.object.isRequired,
  actionSelected: PropTypes.string.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  onClickDialogOpen: PropTypes.func.isRequired,
  onClickDialogClose: PropTypes.func.isRequired,
  onTradeDialogClose: PropTypes.func,
};

export default TradeFormActionCheckDialog;
